import { useLayoutEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';

import AppLoadingIndicator from './AppLoadingIndicator';
import AppSideBar from './AppSideBar';
import AppTopBar from './AppTopBar';

import useUserSessionContext from '../hooks/contexts/useUserSessionContext';

const AppPrivateLayout = () => {
  const { isReady, userSession, login } = useUserSessionContext();

  const didTriggerLogin = useRef(false);

  const shouldRequireLogin = isReady && !userSession;

  useLayoutEffect(() => {
    if (shouldRequireLogin && !didTriggerLogin.current) {
      didTriggerLogin.current = true;
      login();
    }
  }, [shouldRequireLogin, login]);

  if (!userSession) {
    // TODO: remove this temp workaround as soon integration with
    // authorizer is working
    // if (!userSession || !data) {
    return <AppLoadingIndicator isFullScreen />;
  }

  return (
    <div className="mds-layout">
      <AppTopBar />
      <AppSideBar />
      <main id="main-content" className="mds-page mds-container">
        <Outlet />
      </main>
    </div>
  );
};

export default AppPrivateLayout;
